import Vue from 'vue';
import {
  getPageInfo,
  submitDraw,
  doTask,
  fetchShareCode,
  getRedirectUrl
} from './api';
import { resolveComponents, isRiskError } from '@/components/templates/helper';
import actComponentLib from './components/actComponentsLib';
import { AWARD_ERR_CODE } from './constants';

// 奖品列表数据处理
function resolveAwards(awards) {
  return (awards || []).map(award => {
    if (award.rewardType === 'NULL') {
      if (!award.name) {
        return {
          ...award,
          name: '谢谢参与'
        };
      }
    }
    if (award.rewardPoolExtVo) {
      return {
        ...award,
        detail: award.rewardPoolExtVo
      };
    }
    return award;
  });
}

// 中奖奖品数据处理
function resolveLotteryAwards(awards) {
  // errorCode === 0 为有效奖品
  const validAwards = awards.filter(awardItem => {
    return (
      (!awardItem.errorCode ||
        awardItem.errorCode === AWARD_ERR_CODE.SUCCESS) &&
      awardItem.rewardType !== 'NULL'
    );
  });
  const parsedAwards = validAwards.map(awardItem => {
    if (awardItem.rewardType === 'ENTERPRISE_CREDIT') {
      return {
        ...awardItem,
        totalAmount: awardItem.amount / 100
      };
    }
    if (awardItem.message && typeof awardItem.message === 'string') {
      let awardDetail = {};
      try {
        awardDetail = JSON.parse(awardItem.message);
      } catch (e) {
        throw new Error('reward.message 解析错误');
      }
      return {
        ...awardItem,
        detail: awardDetail
      };
    }
    // 如果是礼包类型，解析 userRewardInfos 中的奖品信息
    if (awardItem.rewardType === 'REWARD_PACKAGE') {
      let parsedUserRewardInfos = [];
      if (awardItem.userRewardInfos && awardItem.userRewardInfos.length) {
        parsedUserRewardInfos = resolveLotteryAwards(awardItem.userRewardInfos);
      }
      return {
        ...awardItem,
        parsedUserRewardInfos
      };
    }
    return awardItem;
  });
  return parsedAwards;
}

export default {
  namespaced: true,
  state() {
    return {
      actData: null,
      tplData: null,
      pinnedBtnComponentObjs: [],
      flowComponentObjs: [],
      positionComponentObjs: [],
      lotteryResult: null,
      isShowWinModal: false,
      isShowNoPrizeModal: false,
      shareCode: null,
      actCode: null
    };
  },
  actions: {
    loadConfigurationComponents(_, configurationComponents) {
      console.log('load configurationComponents here', configurationComponents);
    },
    parseCompnents({ commit, dispatch }, { metaInfo, actData }) {
      const components = metaInfo.components;
      if (!components || !components.length) {
        return;
      }
      const [
        pinnedBtnComponentObjs,
        flowComponentObjs,
        positionComponentObjs,
        configurationComponents
      ] = resolveComponents(components, { actData, actComponentLib });
      dispatch('loadConfigurationComponents', configurationComponents);
      // 设置邀请按钮组件和转盘组件无上下间距
      const resolvedFlowComponentObjs = flowComponentObjs.map(obj => {
        if ([1151, 1153].includes(obj.componentTypeId)) {
          return {
            ...obj,
            hasGap: false
          };
        }
        return obj;
      });
      commit('setComponentObjs', {
        pinnedBtnComponentObjs,
        flowComponentObjs: resolvedFlowComponentObjs,
        positionComponentObjs
      });
    },
    async getActData({ commit, dispatch }, actCode) {
      Vue.prototype.$hll.showLoading({});
      let actData;
      try {
        actData = await getPageInfo(actCode);
      } catch (error) {
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
      let metaInfo = {};
      try {
        metaInfo = JSON.parse(actData.metaInfo);
      } catch (e) {
        throw new Error('模板数据 parse 出错');
      }
      if (!actData.taskInfos) {
        actData.taskInfos = [];
      }
      // 奖品数据处理;
      const resolvedAwards = resolveAwards(actData.rewards);
      commit('setActData', {
        ...actData,
        rewards: resolvedAwards
      });
      commit('setTplData', metaInfo);
      // 活动时间检查
      dispatch('actTimeCheck');
      // 解析组件
      dispatch('parseCompnents', { metaInfo, actData });
    },
    async submitDraw({ commit, state, dispatch }) {
      let result;
      try {
        result = await submitDraw({
          actId: state.actData.id,
          taskId: state.actData.lotteryTaskId
        });
      } catch (error) {
        // 如果命中风控则抽中谢谢参与
        if (isRiskError(error.ret)) {
          dispatch('resultMissingAwards');
          return;
        }
        // 如果是没有抽奖次数，提示没有抽奖次数并更新显示
        if (error.ret === 11033) {
          Vue.prototype.$hll.toast('没有抽奖机会了');
          commit('setLotteryResult', []);
          return;
        }
        // 如果请求超时提示活动火爆
        if (error && error.code === 'ECONNABORTED') {
          Vue.prototype.$hll.toast(
            '活动火爆，如已中奖，奖励将稍后放入[我的奖励]中'
          );
          commit('setLotteryResult', []);
          return;
        }
        Vue.prototype.$hll.toast(error && error.msg);
        commit('setLotteryResult', []);
        return;
      }
      // 如果没有返回结果则抽中谢谢参与
      if (!result || !result.length) {
        dispatch('resultMissingAwards');
        return;
      }
      // 如果奖品状态为超时则 toast 提示
      if (result[0].errorCode === AWARD_ERR_CODE.TIMEOUT) {
        Vue.prototype.$hll.toast(
          '活动火爆，如已中奖，奖励将稍后放入[我的奖励]中'
        );
        commit('setLotteryResult', []);
        return;
      }
      const resolvedAwards = resolveLotteryAwards(result);
      // 如果过滤后奖品列表为空也抽中谢谢参与
      if (!resolvedAwards.length) {
        dispatch('resultMissingAwards');
        return;
      }
      // 如果是抽中福袋，福袋奖品过滤后为空，也抽中谢谢参与
      if (
        resolvedAwards.length === 1 &&
        resolvedAwards[0].rewardType === 'REWARD_PACKAGE' &&
        resolvedAwards[0].parsedUserRewardInfos.length === 0
      ) {
        dispatch('resultMissingAwards');
        return;
      }
      // 如果奖品id不在奖项列表中，也抽中谢谢参与
      const awards = state.actData.rewards;
      const targetAward = awards.find(
        award => award.rewardPoolId === resolvedAwards[0].rewardPoolId
      );
      if (!targetAward) {
        dispatch('resultMissingAwards');
        console.error(`奖项不存在：${resolvedAwards[0].rewardPoolId}`);
        return;
      }
      commit('setLotteryResult', resolvedAwards);
    },
    showLotteryResult({ commit, state, dispatch }) {
      // 更新抽奖次数
      dispatch('refreshTaskInfo');
      if (!state.lotteryResult || !state.lotteryResult.length) {
        commit('resetLotteryResult');
        return;
      }
      if (state.lotteryResult[0].rewardType === 'NULL') {
        commit('toggleNoPrizeModal', true);
        return;
      }
      commit('toggleWinModal', true);
    },
    async refreshTaskInfo({ commit, state }) {
      const actData = await getPageInfo(state.actCode);
      if (actData) {
        commit('updateTicketCount', actData.remainTimes);
        commit('updateCredit', actData.credits);
      }
    },
    resultMissingAwards({ commit, state }) {
      // 如果奖品中没有谢谢参与，则 toast 提示
      const awards = state.actData.rewards;
      const noValueAward = awards.find(
        award => award.rewardPoolId === 0 && award.rewardType === 'NULL'
      );
      if (noValueAward) {
        commit('setLotteryResult', [noValueAward]);
      } else {
        Vue.prototype.$hll.toast('很遗憾，您与奖励擦肩而过');
        commit('setLotteryResult', []);
      }
    },
    doShareTask({ state, dispatch }) {
      const taskInfos = state.actData.taskInfos;
      const shareTask = taskInfos.find(task => task.taskCode === 'share');
      if (!shareTask) {
        return;
      }
      dispatch('doTask', shareTask.taskId);
    },
    async doTask({ state, dispatch }, taskId) {
      try {
        await doTask({
          actId: state.actData.id,
          taskId
        });
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        dispatch('refreshTaskInfo');
        throw new Error(error);
      }
    },
    async getShareCode({ commit, state }) {
      if (state.shareCode) {
        return state.shareCode;
      }
      try {
        const shareCode = await fetchShareCode({
          activityId: state.actData.id
        });
        commit('setShareCode', shareCode);
        return shareCode;
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      }
    },
    actTimeCheck({ state }) {
      const { startTime, endTime, currentTime: now } = state.actData;
      if (now < startTime) {
        Vue.prototype.$hll.toast('活动未开始');
        return false;
      }
      if (now > endTime) {
        Vue.prototype.$hll.toast('活动已结束');
        return false;
      }
      return true;
    },
    async getRedirectUrl(_, originUrl) {
      Vue.prototype.$hll.showLoading({});
      try {
        const res = await getRedirectUrl({
          href: originUrl,
          componentTypeId: 1152
        });
        if (res && res.redirectUrl) {
          return res.redirectUrl;
        }
        console.debug(res);
        throw new Error('橙券登陆失败');
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
    }
  },
  mutations: {
    setTplData(state, val) {
      state.tplData = val;
    },
    setActData(state, val) {
      state.actData = val;
    },
    setComponentObjs(
      state,
      { pinnedBtnComponentObjs, flowComponentObjs, positionComponentObjs }
    ) {
      state.pinnedBtnComponentObjs = pinnedBtnComponentObjs;
      state.flowComponentObjs = flowComponentObjs;
      state.positionComponentObjs = positionComponentObjs;
    },
    setLotteryResult(state, val) {
      state.lotteryResult = val;
    },
    resetLotteryResult(state) {
      state.lotteryResult = null;
    },
    updateTicketCount(state, newRemainTimes) {
      state.actData.remainTimes = newRemainTimes;
    },
    toggleWinModal(state, val) {
      state.isShowWinModal = val;
    },
    toggleNoPrizeModal(state, val) {
      state.isShowNoPrizeModal = val;
    },
    setShareCode(state, val) {
      state.shareCode = val;
    },
    initSetActCode(state, actCode) {
      state.actCode = actCode;
    },
    updateCredit(state, credits) {
      state.actData.credits = credits;
    }
  }
};
